import Cookies from 'js-cookie';

export class CookieSetter {
  key: string;
  custom: {
    get: (key: string, ObjectKey?: string) => void;
    set: (key: string, value: any, ObjectKey?: string) => void;
    remove: (key: string, ObjectKey?: string) => void;
  };
  constructor(key: string, custom?: any, type?: any) {
    this.key = key;
    this.custom = custom;
  }
  get(ObjectKey?: string) {
    if (this.custom?.get) {
      return this.custom.get(this.key, ObjectKey);
    }
    console.log(`${this.key}_get_${ObjectKey || ''}`);
    const getItem = Cookies.get(this.key);
    const obj = JSON.parse(getItem || '{}');
    // 기존값에서 한개의 키의 값만 가져올경우 사용
    if (ObjectKey && obj) {
      return obj[ObjectKey] ?? null;
    }
    return obj ?? null;
  }
  set(value: any, ObjectKey?: string) {
    let prevItem = null;
    // 기존값에서 한개의 키의 값만 변경할경우 사용
    if (ObjectKey && Cookies.get(this.key)) {
      prevItem = {
        ...JSON.parse(Cookies.get(this.key) || '{}'),
        [ObjectKey]: value,
      };
    }
    const result = JSON.stringify(prevItem || value);
    if (this.custom?.set) {
      return this.custom.set(this.key, result, ObjectKey);
    }
    console.log(`${this.key}_set_${ObjectKey || ''}`);
    return Cookies.set(this.key, result);
  }
  remove(ObjectKey?: string) {
    if (this.custom?.remove) {
      return this.custom.remove(this.key, ObjectKey);
    }
    let prevItem = null;
    if (Cookies.get(this.key)) {
      console.log(`${this.key}_remove_${ObjectKey || ''}`);

      // 기존값에서 한개의 키의 값만 삭제할경우 사용
      if (ObjectKey && Cookies.get(this.key)) {
        prevItem = {
          ...JSON.parse(Cookies.get(this.key) || '{}'),
        };
        delete prevItem[ObjectKey];
        return Cookies.set(this.key, prevItem);
      }
      return Cookies.remove(this.key);
    } else {
      console.log(`${this.key}_notFound`);
      return;
    }
  }
}
